// How many of the three app flags a user has. The app switcher only renders
// when a user can move between apps, i.e. hasMultipleApps.
export const appCount = (user) =>
  [user?.has_analytics_app, user?.has_sod_app, user?.has_datum_app].filter(
    Boolean
  ).length

export const hasMultipleApps = (user) => appCount(user) > 1
